<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="fa fa-exchange-alt"></i>&nbsp; Sale Reports</h4>
                                <h5 class="card-subtitle">Information about total sale amount respect to buyer</h5>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0"><h6>Buyer Name</h6></th>
                                    <th class="border-0"><h6>Total Amount</h6></th>
                                    <th class="border-0"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(s_report, index) in sales_report">
                                    <td>{{s_report.name}}</td>
                                    <td>{{s_report.total | money}}</td>
                                    <td>
                                        <a @click="viewSummary(s_report.buyer_id)" href="javascript:void(0)">
                                            <h6>View Summary</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "SalesReport",
        computed: {
            ...mapGetters(["currentOrg"])
        },
        data() {
            return {
                sales_report: []
            };
        },
        mounted() {
            this.getSalesReport();
        },
        methods: {
            async getSalesReport() {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/salesReport");

                $(".preloader").fadeOut();
                this.sales_report = result.data;
            },
            async viewSummary(memberid) {
                this.$router.push({name: "salessummary", params: {memberid: memberid}});
            }
        }
    }
</script>

<style scoped>

</style>
